
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexeH_45knvsPxuzKCtuhxbzmq3A52gxj9sNHQK_MhXjK724Meta } from "/opt/atlassian/pipelines/agent/build/pages/index.vue?macro=true";
import { default as team32HbvGyeERa3rXK17BBzFLSeCptlb0cFfSpgxr2zmD0Meta } from "/opt/atlassian/pipelines/agent/build/pages/team.vue?macro=true";
import { default as loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta } from "/opt/atlassian/pipelines/agent/build/pages/login.vue?macro=true";
import { default as indexv4v2crJ6tEd2TADM4_453UUGTlf4pmx4J_Cd7iPHBZoU0Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/index.vue?macro=true";
import { default as _91id_93UP0DsbIoRBfK2o8YtiuMYtF7LVhk4uIxZkrE2UcGnB0Meta } from "/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue?macro=true";
import { default as indexR41tkLjgU6dn1UAy_45Ygn_454vSOON8s6bsEB1wtltEQScMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue?macro=true";
import { default as indexa_45y_Fh_wpE_PINMkVlBBMU9jn1Z6vunsZpFtW2PZZEAMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/retours/index.vue?macro=true";
import { default as createkP_455fu_45ZCQP8592DcOYeb03fhk8ma9KNBcXS_b6qPtsMeta } from "/opt/atlassian/pipelines/agent/build/pages/account/retours/create.vue?macro=true";
import { default as accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta } from "/opt/atlassian/pipelines/agent/build/pages/account.vue?macro=true";
import { default as contacttM7DxDzsCtsQg9Tlt72mqfBZV0c4BuApP0ZdcGkzW7IMeta } from "/opt/atlassian/pipelines/agent/build/pages/contact.vue?macro=true";
import { default as historyyNu8NhT12Aa44N1coqAVo3TrVg6XHdTBf2mNcAmRsUYMeta } from "/opt/atlassian/pipelines/agent/build/pages/history.vue?macro=true";
import { default as servicez5oUGL3wU2Xe7Xd2iSWiAL0Z_T6X46079VAcC6_45PDdsMeta } from "/opt/atlassian/pipelines/agent/build/pages/service.vue?macro=true";
import { default as passwordxtD4jDwHs3OzqJJRyws_45ptFwJ2udW0ZZcAdrEUtMvbUMeta } from "/opt/atlassian/pipelines/agent/build/pages/password.vue?macro=true";
import { default as registerR9X3EbDDydy0z2KY021i_dLm8_pgLrz_I7Nqi8sdRLsMeta } from "/opt/atlassian/pipelines/agent/build/pages/register.vue?macro=true";
import { default as _91_46_46_46slug_93D83QY4Qi4ch3jphOOqWb3ZYLsOmqQTlPyJDYEQxD1ZIMeta } from "/opt/atlassian/pipelines/agent/build/pages/[...slug].vue?macro=true";
import { default as _91id_93S97rMf3J1NE_xGCVL_zXQdsl6v1wohgdP3OlNMvE4l4Meta } from "/opt/atlassian/pipelines/agent/build/pages/jobs/[id].vue?macro=true";
import { default as quick_45addna0HgWApgYGfmoJuiuw76FeuM4EQ1oScicQfD_45g_45EDIMeta } from "/opt/atlassian/pipelines/agent/build/pages/quick-add.vue?macro=true";
import { default as indexGShxXLM5bcAaASODXDIjiMHkiUMzNvTs1sZ2KkoMPnUMeta } from "/opt/atlassian/pipelines/agent/build/pages/blog/index.vue?macro=true";
import { default as indexXmgAqSk6ZCSNf3WJrYMN2INkZLJ3BAkjT2GRayFNU5MMeta } from "/opt/atlassian/pipelines/agent/build/pages/cart/index.vue?macro=true";
import { default as indexHlZddjfyH5z7C9T5lp8lUIpP_FaC6npBOL0LJF_EFzAMeta } from "/opt/atlassian/pipelines/agent/build/pages/jobs/index.vue?macro=true";
import { default as _91slug_93aZqSqFjULZ_DJvsvvXvGMpuSAZ4n6b49SM4u_lR05MwMeta } from "/opt/atlassian/pipelines/agent/build/pages/blog/[slug].vue?macro=true";
import { default as indexj015ZMjRauqqPdMHnFlpuj9kdVabJWjpGQg2lBfZEqIMeta } from "/opt/atlassian/pipelines/agent/build/pages/green/index.vue?macro=true";
import { default as history_45newaifran3Ljy7YnqsptzRtOtpnBYineQWZjAOhgA4pjcQMeta } from "/opt/atlassian/pipelines/agent/build/pages/history-new.vue?macro=true";
import { default as indexm0APDYGlKfgYmHl0vV0jBQHpUtqdZvfiVUr6kpsTlx4Meta } from "/opt/atlassian/pipelines/agent/build/pages/advice/index.vue?macro=true";
import { default as _91slug_93oDIXeFtbcYkGblMu8fzbUOJRXJH9XoCnqYDxpN7FQ3YMeta } from "/opt/atlassian/pipelines/agent/build/pages/green/[slug].vue?macro=true";
import { default as installationu8faG_453NkvcU2qQhxLKz82c2ekvzTDojbNUjMZfpPsoMeta } from "/opt/atlassian/pipelines/agent/build/pages/installation.vue?macro=true";
import { default as _91id_9300X0kvRh4IG1t10GTf5Qk2j2kpLwctY0_45jtffkyh_45MEMeta } from "/opt/atlassian/pipelines/agent/build/pages/product/[id].vue?macro=true";
import { default as _91_46_46_46slug_93bs2yKtyfJAQqmea1BoG72ZPIYPM_456xXWbSPTcJ_xE74Meta } from "/opt/atlassian/pipelines/agent/build/pages/qr/[...slug].vue?macro=true";
import { default as _91slug_933PsLrSm5cBTMP6vdTsziNVRCgjiu0oA79rNmrsRs52gMeta } from "/opt/atlassian/pipelines/agent/build/pages/advice/[slug].vue?macro=true";
import { default as indexOJVMzLp2cMXvQ8Zq9RaHPuv8glohfnSTFTC4_458f2WtIMeta } from "/opt/atlassian/pipelines/agent/build/pages/dealers/index.vue?macro=true";
import { default as _91id_93uMtyGghSx_Ij8BgaT51_vy4NO_4REok2p6qmDCC2xScMeta } from "/opt/atlassian/pipelines/agent/build/pages/employee/[id].vue?macro=true";
import { default as completedCE_1ImTSJ_bOiEZXaslW_PurhiIJiHdsE5lk4Fc8l9wMeta } from "/opt/atlassian/pipelines/agent/build/pages/cart/completed.vue?macro=true";
import { default as _91slug_93VW_jx7G7qOTX7ElGu8XyBaHtZsFXqNoZFHN8Mmuc_QsMeta } from "/opt/atlassian/pipelines/agent/build/pages/dealers/[slug].vue?macro=true";
import { default as password_45reseti3Cjdbn1FbzZAqGB_knu03tHP7Y3O5A26JVuMSwhVu8Meta } from "/opt/atlassian/pipelines/agent/build/pages/password-reset.vue?macro=true";
import { default as mailing_45hd6ZA_4532CxiPjyi814K7LazYlJQOSbI0Yaqwv_oOIoMeta } from "/opt/atlassian/pipelines/agent/build/pages/campagne/mailing.vue?macro=true";
import { default as _91_46_46_46filters_93YsWvuPL6xNkSVedzOHormB5LGfeIrynkz9Bkt8ncIj0Meta } from "/opt/atlassian/pipelines/agent/build/pages/faq/[...filters].vue?macro=true";
import { default as register_45as_45dealer_45kobfrMCItIeN604eibbt3yREayHV_45pGlnG5E2xCDWgMeta } from "/opt/atlassian/pipelines/agent/build/pages/register-as-dealer.vue?macro=true";
import { default as _91type_93FNtvqj7exHEU5wG7sitaIWUYmM5TV8UpzC9VzsmnidsMeta } from "/opt/atlassian/pipelines/agent/build/pages/products/[category]/[type].vue?macro=true";
import { default as _91type_93KIb0_MzTEes6AVayCHy7dZaUn0iIUy2LpdPSsKMOXL0Meta } from "/opt/atlassian/pipelines/agent/build/pages/second-chances/[category]/[type].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "team___nl",
    path: "/nl/team",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/team.vue")
  },
  {
    name: "team___en",
    path: "/en/team",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/team.vue")
  },
  {
    name: "team___de",
    path: "/de/team",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/team.vue")
  },
  {
    name: "team___fr",
    path: "/fr/team",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/team.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/index.vue")
  },
  {
    name: "login___nl",
    path: "/nl/login",
    meta: loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginfD_rUPL4hV4jhtvGKktR51FF7i0qHNkHLcUE7hZavoAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/login.vue")
  },
  {
    name: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta?.name,
    path: "/nl/account",
    meta: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account___nl",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-orders-id___nl",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___nl",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-retours___nl",
    path: "retours",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/index.vue")
  },
  {
    name: "account-retours-create___nl",
    path: "retours/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/create.vue")
  }
]
  },
  {
    name: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta?.name,
    path: "/en/account",
    meta: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account___en",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-orders-id___en",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___en",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-retours___en",
    path: "retours",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/index.vue")
  },
  {
    name: "account-retours-create___en",
    path: "retours/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/create.vue")
  }
]
  },
  {
    name: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta?.name,
    path: "/de/account",
    meta: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account___de",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-orders-id___de",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___de",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-retours___de",
    path: "retours",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/index.vue")
  },
  {
    name: "account-retours-create___de",
    path: "retours/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/create.vue")
  }
]
  },
  {
    name: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta?.name,
    path: "/fr/account",
    meta: accountZbTLfGauMi2FouuOVqkRqQKOD0fXvf_cf0uPo2zhspMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account.vue"),
    children: [
  {
    name: "account___fr",
    path: "",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/index.vue")
  },
  {
    name: "account-orders-id___fr",
    path: "orders/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___fr",
    path: "orders",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/orders/index.vue")
  },
  {
    name: "account-retours___fr",
    path: "retours",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/index.vue")
  },
  {
    name: "account-retours-create___fr",
    path: "retours/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/account/retours/create.vue")
  }
]
  },
  {
    name: "contact___nl",
    path: "/nl/contact",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/de/contact",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact.vue")
  },
  {
    name: "contact___fr",
    path: "/fr/contact",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/contact.vue")
  },
  {
    name: "history___nl",
    path: "/nl/history",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history.vue")
  },
  {
    name: "history___en",
    path: "/en/history",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history.vue")
  },
  {
    name: "history___de",
    path: "/de/history",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history.vue")
  },
  {
    name: "history___fr",
    path: "/fr/history",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history.vue")
  },
  {
    name: "service___nl",
    path: "/nl/service",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/service.vue")
  },
  {
    name: "service___en",
    path: "/en/service",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/service.vue")
  },
  {
    name: "service___de",
    path: "/de/service",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/service.vue")
  },
  {
    name: "service___fr",
    path: "/fr/service",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/service.vue")
  },
  {
    name: "password___nl",
    path: "/nl/password",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password.vue")
  },
  {
    name: "password___en",
    path: "/en/password",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password.vue")
  },
  {
    name: "password___de",
    path: "/de/password",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password.vue")
  },
  {
    name: "password___fr",
    path: "/fr/password",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password.vue")
  },
  {
    name: "register___nl",
    path: "/nl/register",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register.vue")
  },
  {
    name: "slug___nl",
    path: "/nl/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/de/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[...slug].vue")
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/[...slug].vue")
  },
  {
    name: "jobs-id___nl",
    path: "/nl/jobs/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/[id].vue")
  },
  {
    name: "jobs-id___en",
    path: "/en/jobs/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/[id].vue")
  },
  {
    name: "jobs-id___de",
    path: "/de/jobs/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/[id].vue")
  },
  {
    name: "jobs-id___fr",
    path: "/fr/jobs/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/[id].vue")
  },
  {
    name: "quick-add___nl",
    path: "/nl/quick-add",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/quick-add.vue")
  },
  {
    name: "quick-add___en",
    path: "/en/quick-add",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/quick-add.vue")
  },
  {
    name: "quick-add___de",
    path: "/de/quick-add",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/quick-add.vue")
  },
  {
    name: "quick-add___fr",
    path: "/fr/quick-add",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/quick-add.vue")
  },
  {
    name: "blog___nl",
    path: "/nl/blog",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/index.vue")
  },
  {
    name: "blog___en",
    path: "/en/blog",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/index.vue")
  },
  {
    name: "blog___de",
    path: "/de/blog",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/index.vue")
  },
  {
    name: "blog___fr",
    path: "/fr/blog",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/index.vue")
  },
  {
    name: "cart___nl",
    path: "/nl/cart",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/index.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/index.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/index.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/index.vue")
  },
  {
    name: "jobs___nl",
    path: "/nl/jobs",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/index.vue")
  },
  {
    name: "jobs___en",
    path: "/en/jobs",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/index.vue")
  },
  {
    name: "jobs___de",
    path: "/de/jobs",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/index.vue")
  },
  {
    name: "jobs___fr",
    path: "/fr/jobs",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/jobs/index.vue")
  },
  {
    name: "blog-slug___nl",
    path: "/nl/blog/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___en",
    path: "/en/blog/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___de",
    path: "/de/blog/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___fr",
    path: "/fr/blog/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/blog/[slug].vue")
  },
  {
    name: "green___nl",
    path: "/nl/green",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/index.vue")
  },
  {
    name: "green___en",
    path: "/en/green",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/index.vue")
  },
  {
    name: "green___de",
    path: "/de/green",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/index.vue")
  },
  {
    name: "green___fr",
    path: "/fr/green",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/index.vue")
  },
  {
    name: "history-new___nl",
    path: "/nl/history-new",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history-new.vue")
  },
  {
    name: "history-new___en",
    path: "/en/history-new",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history-new.vue")
  },
  {
    name: "history-new___de",
    path: "/de/history-new",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history-new.vue")
  },
  {
    name: "history-new___fr",
    path: "/fr/history-new",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/history-new.vue")
  },
  {
    name: "advice___nl",
    path: "/nl/advice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/index.vue")
  },
  {
    name: "advice___en",
    path: "/en/advice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/index.vue")
  },
  {
    name: "advice___de",
    path: "/de/advice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/index.vue")
  },
  {
    name: "advice___fr",
    path: "/fr/advice",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/index.vue")
  },
  {
    name: "green-slug___nl",
    path: "/nl/green/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/[slug].vue")
  },
  {
    name: "green-slug___en",
    path: "/en/green/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/[slug].vue")
  },
  {
    name: "green-slug___de",
    path: "/de/green/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/[slug].vue")
  },
  {
    name: "green-slug___fr",
    path: "/fr/green/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/green/[slug].vue")
  },
  {
    name: "installation___nl",
    path: "/nl/installation",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/installation.vue")
  },
  {
    name: "installation___en",
    path: "/en/installation",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/installation.vue")
  },
  {
    name: "installation___de",
    path: "/de/installation",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/installation.vue")
  },
  {
    name: "installation___fr",
    path: "/fr/installation",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/installation.vue")
  },
  {
    name: "product-id___nl",
    path: "/nl/product/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/product/[id].vue")
  },
  {
    name: "product-id___en",
    path: "/en/product/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/product/[id].vue")
  },
  {
    name: "product-id___de",
    path: "/de/product/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/product/[id].vue")
  },
  {
    name: "product-id___fr",
    path: "/fr/product/:id()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/product/[id].vue")
  },
  {
    name: "qr-slug___nl",
    path: "/nl/qr/:slug(.*)*",
    meta: _91_46_46_46slug_93bs2yKtyfJAQqmea1BoG72ZPIYPM_456xXWbSPTcJ_xE74Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/qr/[...slug].vue")
  },
  {
    name: "qr-slug___en",
    path: "/en/qr/:slug(.*)*",
    meta: _91_46_46_46slug_93bs2yKtyfJAQqmea1BoG72ZPIYPM_456xXWbSPTcJ_xE74Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/qr/[...slug].vue")
  },
  {
    name: "qr-slug___de",
    path: "/de/qr/:slug(.*)*",
    meta: _91_46_46_46slug_93bs2yKtyfJAQqmea1BoG72ZPIYPM_456xXWbSPTcJ_xE74Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/qr/[...slug].vue")
  },
  {
    name: "qr-slug___fr",
    path: "/fr/qr/:slug(.*)*",
    meta: _91_46_46_46slug_93bs2yKtyfJAQqmea1BoG72ZPIYPM_456xXWbSPTcJ_xE74Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/qr/[...slug].vue")
  },
  {
    name: "advice-slug___nl",
    path: "/nl/advice/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/[slug].vue")
  },
  {
    name: "advice-slug___en",
    path: "/en/advice/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/[slug].vue")
  },
  {
    name: "advice-slug___de",
    path: "/de/advice/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/[slug].vue")
  },
  {
    name: "advice-slug___fr",
    path: "/fr/advice/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/advice/[slug].vue")
  },
  {
    name: "dealers___nl",
    path: "/nl/dealers",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/index.vue")
  },
  {
    name: "dealers___en",
    path: "/en/dealers",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/index.vue")
  },
  {
    name: "dealers___de",
    path: "/de/dealers",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/index.vue")
  },
  {
    name: "dealers___fr",
    path: "/fr/dealers",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/index.vue")
  },
  {
    name: "employee-id___nl",
    path: "/nl/employee/:id()",
    meta: _91id_93uMtyGghSx_Ij8BgaT51_vy4NO_4REok2p6qmDCC2xScMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/employee/[id].vue")
  },
  {
    name: "employee-id___en",
    path: "/en/employee/:id()",
    meta: _91id_93uMtyGghSx_Ij8BgaT51_vy4NO_4REok2p6qmDCC2xScMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/employee/[id].vue")
  },
  {
    name: "employee-id___de",
    path: "/de/employee/:id()",
    meta: _91id_93uMtyGghSx_Ij8BgaT51_vy4NO_4REok2p6qmDCC2xScMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/employee/[id].vue")
  },
  {
    name: "employee-id___fr",
    path: "/fr/employee/:id()",
    meta: _91id_93uMtyGghSx_Ij8BgaT51_vy4NO_4REok2p6qmDCC2xScMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/employee/[id].vue")
  },
  {
    name: "cart-completed___nl",
    path: "/nl/cart/completed",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/completed.vue")
  },
  {
    name: "cart-completed___en",
    path: "/en/cart/completed",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/completed.vue")
  },
  {
    name: "cart-completed___de",
    path: "/de/cart/completed",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/completed.vue")
  },
  {
    name: "cart-completed___fr",
    path: "/fr/cart/completed",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/cart/completed.vue")
  },
  {
    name: "dealers-slug___nl",
    path: "/nl/dealers/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___en",
    path: "/en/dealers/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___de",
    path: "/de/dealers/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/[slug].vue")
  },
  {
    name: "dealers-slug___fr",
    path: "/fr/dealers/:slug()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/dealers/[slug].vue")
  },
  {
    name: "password-reset___nl",
    path: "/nl/password-reset",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password-reset.vue")
  },
  {
    name: "password-reset___en",
    path: "/en/password-reset",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password-reset.vue")
  },
  {
    name: "password-reset___de",
    path: "/de/password-reset",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password-reset.vue")
  },
  {
    name: "password-reset___fr",
    path: "/fr/password-reset",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/password-reset.vue")
  },
  {
    name: "campagne-mailing___nl",
    path: "/nl/campagne/mailing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/campagne/mailing.vue")
  },
  {
    name: "campagne-mailing___en",
    path: "/en/campagne/mailing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/campagne/mailing.vue")
  },
  {
    name: "campagne-mailing___de",
    path: "/de/campagne/mailing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/campagne/mailing.vue")
  },
  {
    name: "campagne-mailing___fr",
    path: "/fr/campagne/mailing",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/campagne/mailing.vue")
  },
  {
    name: "faq-filters___nl",
    path: "/nl/faq/:filters(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/faq/[...filters].vue")
  },
  {
    name: "faq-filters___en",
    path: "/en/faq/:filters(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/faq/[...filters].vue")
  },
  {
    name: "faq-filters___de",
    path: "/de/faq/:filters(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/faq/[...filters].vue")
  },
  {
    name: "faq-filters___fr",
    path: "/fr/faq/:filters(.*)*",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/faq/[...filters].vue")
  },
  {
    name: "register-as-dealer___nl",
    path: "/nl/register-as-dealer",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register-as-dealer.vue")
  },
  {
    name: "register-as-dealer___en",
    path: "/en/register-as-dealer",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register-as-dealer.vue")
  },
  {
    name: "register-as-dealer___de",
    path: "/de/register-as-dealer",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register-as-dealer.vue")
  },
  {
    name: "register-as-dealer___fr",
    path: "/fr/register-as-dealer",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/register-as-dealer.vue")
  },
  {
    name: "products-category-type___nl",
    path: "/nl/products/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/products/[category]/[type].vue")
  },
  {
    name: "products-category-type___en",
    path: "/en/products/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/products/[category]/[type].vue")
  },
  {
    name: "products-category-type___de",
    path: "/de/products/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/products/[category]/[type].vue")
  },
  {
    name: "products-category-type___fr",
    path: "/fr/products/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/products/[category]/[type].vue")
  },
  {
    name: "second-chances-category-type___nl",
    path: "/nl/second-chances/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/second-chances/[category]/[type].vue")
  },
  {
    name: "second-chances-category-type___en",
    path: "/en/second-chances/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/second-chances/[category]/[type].vue")
  },
  {
    name: "second-chances-category-type___de",
    path: "/de/second-chances/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/second-chances/[category]/[type].vue")
  },
  {
    name: "second-chances-category-type___fr",
    path: "/fr/second-chances/:category()/:type()",
    component: () => import("/opt/atlassian/pipelines/agent/build/pages/second-chances/[category]/[type].vue")
  }
]